import { useTranslation } from 'react-i18next';

import { Pagination as AntPagination, PaginationProps } from 'antd';

import { CONFIG } from 'features/Pagination/config/config';
import { EPagination, EPaginationParams } from 'features/Pagination/model/types';
import { useMedia, useSearchParamsWithHash } from 'shared/hooks';
import { getNoun } from 'shared/utils';

import styles from './Pagination.module.scss';

export interface IPaginationProps extends PaginationProps {
	count?: number;
	minCount?: number;
	nouns?: [string, string, string];
}

export const Pagination = ({ count = 1, minCount = EPagination.MIN, nouns, ...props }: IPaginationProps) => {
	const isMd = useMedia();
	const { t } = useTranslation();
	const [searchParams, setSearchParams] = useSearchParamsWithHash();

	const offset = searchParams.get(EPaginationParams.OFFSET);
	const offsetIndex = isNaN(Number(offset)) ? 0 : Number(offset);

	const limit = searchParams.get(EPaginationParams.LIMIT);
	const perPage = isNaN(Number(limit)) || Number(limit) < 1 ? CONFIG.PER_PAGE : Number(limit);

	const onPaginate = (page: number, pageSize: number) => {
		const newPerPage = pageSize || CONFIG.PER_PAGE;
		const newPageNumber = page || 1;
		const newOffsetIndex = newPerPage * (newPageNumber - 1);

		searchParams.set(EPaginationParams.LIMIT, newPerPage.toString());
		searchParams.set(EPaginationParams.OFFSET, newOffsetIndex.toString());

		setSearchParams(searchParams);
	};

	return (
		count > (perPage < minCount ? perPage : minCount) && (
			<AntPagination
				{...props}
				className={styles.pagination}
				total={count}
				showTotal={
					isMd
						? undefined
						: (total) => t(`Всего ${total} ${getNoun(count, nouns || [t('запись'), t('записи'), t('записей')])}`)
				}
				showSizeChanger
				pageSize={perPage}
				pageSizeOptions={CONFIG.PER_PAGE_OPTIONS}
				defaultCurrent={Math.floor(offsetIndex / perPage) + 1}
				onChange={onPaginate}
				align={isMd ? 'center' : 'start'}
			/>
		)
	);
};

export default Pagination;
